import React, {useState} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ForwardIcon from '@mui/icons-material/Forward';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {Inc,Owner,Page,PageSearchCondition} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import PageInput from './PageInput';
import Alert from './Alert';
import Yesno from './Yesno';
import Loading from './Loading';
import PageListSearch from './PageListSearch';
import Title from './Title';
import AppBank from './AppBank';

interface PageListProps {
	owner:Owner,
	managerId:number,
	bank:AppBank,
}
//let p:number = 1;

const PageList = (props:PageListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const defPages:Page[] = [];
	const defCheckedIds:number[] = [];

	const [states,setStates] = useState({
		pages:defPages,
		checkedIds:defCheckedIds,
		allChecked:false,
        isLoading:true,
		isInput:false,
		currentPage:1,
		pager:null,
		yesno:"",
		alert:"",
        cond:Inc.defaultPageSearchCondition(),
		redirectId: 0,
    });
    const search = (cond:PageSearchCondition,page:number)=>{
        //console.log("search",cond);
		setStates({...states,"isLoading":true});
		// if( first ){
		// 	p = 1;
		// }
		window.scrollTo(0,0);
        Ajax.search("page/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,pages:res.pages,cond:cond,currentPage:page,pager:res.pager,isLoading:false,checkedIds:[],allChecked:false,yesno:""});
            } else {
                setStates({...states,"isLoading":false,yesno:""});
            }
        });
	}
	const jump = (to:number)=>{
		//send(values,p);
		//p = to;
		search(states.cond,to);
	}
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id)});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.pages.length ; i++ ){
				ids.push( states.pages[i].page_id );
			}
			setStates({...states,"checkedIds":ids,"allChecked":true});
		}
	}
	const remove = ()=>{
		//※「非公開」で、在庫が０の商品のみ
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"シリーズを選択して下さい"});
		} else {
			setStates({...states,"yesno":"remove"});
		}
	}
	const yes = ()=>{
		if( states.yesno==="remove" ){
			Ajax.send("page/hide",{page_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}
	const openInput = ()=>{
		setStates({...states,isInput:true});
	}
	const closeInput = (updated:boolean,id:number)=>{
		if( updated ){
			//search(states.cond);
			setStates({...states,redirectId:id,isInput:false});
		} else {
			setStates({...states,isInput:false});
		}
	}

	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択したシリーズを削除します。\n本当によろしいですか？";
		}
	}

	if( states.redirectId>0 ){
		return <Redirect to={"/page/"+states.redirectId}/>
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}


	return (
		<div id="page_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="シリーズ（本・雑貨）" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
                            架空ストアに登録してある本・雑貨のシリーズ一覧です。条件を指定してシリーズを検索することもできます。<br/>
                            新しいシリーズを登録する場合は、「シリーズを登録」ボタンをクリックして下さい。<br/>
							<Hidden mdUp implementation="js">
								<div style={{width:"100%",maxWidth:"160px",marginRight:"0",marginLeft:"auto"}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
									<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput}><AddIcon/>シリーズを登録</Button>
								</FormControl>
								</div>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>
									</TableCell>
									<TableCell className={classes.tableHeadNowrap} align='center'>シリーズ名</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>商品数</TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableHeadNowrap} align='center'>状態</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.pages.map( (page:any,index:number)=>{
                            const key = "page"+index;
							const to = "/page/"+String(page.page_id);
							const v = states.checkedIds.includes(page.page_id);
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellDense} style={{width:'2em'}}>
										<Checkbox
						checked={v}
						value={String(page.page_id)}
						onClick={()=>checkId(page.page_id)}
						color="primary"
						className={classes.listCheckbox}
										/>
                                    </TableCell>
									<TableCell className={classes.tableCellDense}>
                                        <span className={classes.pageId}>ID:{page.page_id}</span>　
                                        <Hidden smUp implementation="js">
                                            <br/>
                                        </Hidden>
										{page.page_name}
									</TableCell>
                                    <TableCell className={classes.tableCellNowrap} align="right">{parseInt(page.num_item)+0}</TableCell>
                                    <Hidden smDown implementation="js">
										<TableCell className={classes.tableCellNowrap} align="center">
											{Tools.colorLabel("page_status",page.status,page.status_label)}<br/>
										</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellNowrap} align="right">
                                        <Link to={to}><IconButton aria-label="edit" className={classes.primary} style={{margin:'0',padding:'0'}}><ForwardIcon/></IconButton></Link>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・修正" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput}><AddIcon/>シリーズを登録</Button>
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックしたシリーズを</div>
							<Button variant="outlined" color="secondary" onClick={remove} size='small' disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
						</FormControl>
					</Paper>

                    <Paper className={classes.paper}>
                        <PageListSearch update={search} bank={props.bank} bankKey={"savedPageListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>
			<PageInput pageId={0} isOpen={states.isInput} owner={props.owner} managerId={props.managerId} close={closeInput}/>
            <Loading isLoading={states.isLoading}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
		</div>
	);
}

export default PageList;
